import { render, staticRenderFns } from "./NewsMediaDetails.vue?vue&type=template&id=7209de82&scoped=true"
import script from "./NewsMediaDetails.vue?vue&type=script&lang=js"
export * from "./NewsMediaDetails.vue?vue&type=script&lang=js"
import style0 from "./NewsMediaDetails.vue?vue&type=style&index=0&id=7209de82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7209de82",
  null
  
)

export default component.exports